<div class="d-flex w-100">
  <div *ngIf="file?.name" class="item-w-100 d-flex">
    <!--    <span class="file-text btn-cursor" (click)="clickFile()">{{file?.name}}</span>-->
    <span [ngClass]="{'mw-130px': isMobile}" class="file-text text-truncate">{{ file?.name }}</span>
    <font-awesome (click)="delete()" *ngIf="!roles.agent.includes(_initInfo?.userType)"
                  [cssClass]="'ml-4px'"
                  [icon]="'fa-regular fa-xmark'" role="button"></font-awesome>
  </div>
  <div (click)="imgFileInput.click()" *ngIf="!file?.name && !roles.agent.includes(_initInfo?.userType)"
       class="item-file btn-cursor">
    <input disabled hidden name="filename" placeholder="Select a File">
    <input #imgFileInput (change)="fileSelected($event)" accept="image/*" hidden type="file"/>
    <font-awesome [cssClass]="'icon-21px'" [icon]="'fa-light fa-image'" id="select-icon" role="button"></font-awesome>
  </div>
</div>
